const STORAGE_PREFIX = 'event_tokens_'

export function storeEventTokens(eventId, editToken, creationToken) {
  localStorage.setItem(`${STORAGE_PREFIX}edit_${eventId}`, editToken)
  localStorage.setItem(`${STORAGE_PREFIX}creation_${eventId}`, creationToken)
}

export function getEditToken(eventId) {
  return localStorage.getItem(`${STORAGE_PREFIX}edit_${eventId}`)
}

export function getCreationToken(eventId) {
  return localStorage.getItem(`${STORAGE_PREFIX}creation_${eventId}`)
}

export function removeEventTokens(eventId) {
  localStorage.removeItem(`${STORAGE_PREFIX}edit_${eventId}`)
  localStorage.removeItem(`${STORAGE_PREFIX}creation_${eventId}`)
}

